export default __webpack_public_path__ + "static/media/kiricocho-logo-disabled.83107adf.svg";